import {PaymentTypes, BookingType} from "app/app.types";
import {BookingStatusTypes, StatusStandbyPending, StatusPendingPayment} from 'app/bookingStatusTypes';
import ObjectCopyService from "external-services/object-copy-service/index";
import StatusConfigService from "external-services/status-config-service/index";
import PouchActions, {PouchDocType} from 'app/actions/pouch.actions';
import AdminService from 'external-services/diary-admin-service';

const NS = 'StatusCtrl'; // jshint ignore:line

export default function StatusCtrl(
  $rootScope, $timeout, $scope, $mdToast, $mdDialog, $filter, unregister
) {
  "ngInject";

  var vm = this;

  vm.BookingType = BookingType;
  vm.PaymentTypes = PaymentTypes;
  vm.BookingStatusTypes = BookingStatusTypes;
  vm.StatusStandbyPending = StatusStandbyPending;
  vm.StatusPendingPayment = StatusPendingPayment;

  var listeners = [];
  var highestOrder;
  var saveInterval;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.state = vm.LOADING;
  vm.statusOptions = [];
  //-- define public methods
  vm.updateStatus = updateStatus;
  vm.newStatus = newStatus;
  vm.editStatus = editStatus;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.save = save;
  vm.getCurrentStatusColor = getCurrentStatusColor;
  vm.checkForFloorplanActive = checkForFloorplanActive;
  vm.waitingToSave = false;
  vm.statusColorInfo = [];

  vm.venue = AdminService.getVenue();

  // listeners.push($rootScope.$on('pouch-synced-doctype-status', getStatusList));
  listeners.push(PouchActions.handlePouchSyncedDoctype(PouchDocType.status, () => getStatusList()));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  getStatusList();

  function getStatusList() {
    vm.isFloorPlanActive = vm.venue.enableNewFloorPlan;
    console.log('vm.isFloorPlanActive', vm.isFloorPlanActive);
    StatusConfigService.getBookingStatus().then(function (statusOptions) {
      vm.state = vm.ENTER;
      var orderList = $filter('orderBy')(statusOptions, 'order');


      var lastOrder = 0;
      for (var i = 0; i < orderList.length; i++) {
        var status = orderList[i];
        if (!isNaN(status.order)) {
          if (status.order === lastOrder) {
            status.order = lastOrder += 1;
          }
        } else {
          status.order = lastOrder += 1;
        }
        lastOrder = status.order;
      }
      highestOrder = lastOrder;

      vm.statusOptions = orderList;
      console.log('statusOptions List', vm.statusOptions);
      vm.waitingToSave = false;
    });
  }

  function moveUp(index, status) {
    var statusAbove = $filter('orderBy')(vm.statusOptions, 'order')[index - 1];
    var aboveOrder = statusAbove.order;
    statusAbove.order = status.order;
    status.order = aboveOrder;
    saveDelay();
  }

  function moveDown(index, status) {
    var statusBelow = $filter('orderBy')(vm.statusOptions, 'order')[index + 1];
    var belowOrder = statusBelow.order;
    statusBelow.order = status.order;
    status.order = belowOrder;
    saveDelay();
  }

  function saveDelay() {
    vm.waitingToSave = true;
    if (saveInterval) {
      $timeout.cancel(saveInterval);
    }
    saveInterval = $timeout(save, 2000);
  }

  function save() {
    if (saveInterval) {
      $timeout.cancel(saveInterval);
    }
    vm.state = vm.LOADING;
    StatusConfigService.saveStatusList(vm.statusOptions).then(function () {

      vm.state = vm.ENTER;
      $mdToast.show(
        $mdToast.simple()
        .content('Status Saved')
        .position('bottom right')
        .theme('saved')
        .hideDelay(3000)
      );
    }).catch(function () {
      vm.state = vm.ERROR;
    });
  }

  function updateStatus() {
    saveDelay();
  }

  function newStatus(evt) {
    $mdDialog.show({
      controller: 'StatusEditorCtrl',
      controllerAs: 'vm',
      clickOutsideToClose: true,
      locals: {
        status: null,
        highestOrder: highestOrder,
        statuses: vm.statusOptions,
        colorInfo: ''
      },
      templateUrl: 'app/settings/status/statusEditor.html',
      targetEvent: evt
    });
  }

  function editStatus(evt, status) {
    $mdDialog.show({
      controller: 'StatusEditorCtrl',
      controllerAs: 'vm',
      clickOutsideToClose: true,
      locals: {
        status: ObjectCopyService.angularSafeCopy(status),
        highestOrder: highestOrder,
        statuses: vm.statusOptions,
        colorInfo: vm.statusColorInfo.find(info => info.statusId === status._id)
      },
      templateUrl: 'app/settings/status/statusEditor.html',
      targetEvent: evt
    });
  }

  function getCurrentStatusColor(colorInfo) {
    vm.statusColorInfo.push(colorInfo);
  }

  function checkForFloorplanActive(statusItem) {
    if (vm.isFloorPlanActive) {
      return true;
    }

    return !(!vm.isFloorPlanActive && (statusItem.code === 'WB' || statusItem.code === 'CT' ||
      statusItem.code === 'OT' || statusItem.code === 'BC'));
  }

}
